/**
 * @module experience/shop/product-details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Product, Sku, ImageUrl } from '@support/api/common/product.interface';

export interface DefaultProductDetailsModel {
  productDetails: ProductDetails;
}

export interface ProductDetails extends Product {
  sku?: Sku;
  hasDeal?: boolean;
  newProduct?: ProductSku;
  refurbishedProduct?: ProductSku;
  defaultCondition?: string;
  isNewDeviceAvailable?: boolean;
  isRefurbishedDeviceAvailable?: boolean;
  defaultSelection?: string;
  priceOption?: string;
  defaultMemory?: string;
  defaultColor?: string;
  familyCode?: string;
  offerId?: string;
  legalText?: string;
  type?: string;
  color?: string;
  rating?: number;
}
export class ProductSku {
  [key: string]: SkuDetails;
}

export interface Swatch {
  color: string;
  memory: string;
}

export interface SkuDetails extends Sku {
  dollarAmount?: string;
  centsAmount?: string;
  imageUrl?: ImageUrl[];
  Line?: string;
}

export interface EpinConflictResponse {
  hasOnlyByos?: boolean;
  conflictingMessage?: string[];
  hasConflict?: boolean;
}

export enum ProductTypes {
  EPIN,
  HARDGOOD,
  SOFTGOOD,
}

export interface EpinCount {
  selectedEpinAmount?: string;
  selectedItem?: SelectedItem;
  deviceDetails?: DeviceDetails;
  selectedQuantity?: number;
}

export interface SelectedItem {
  id?: string;
  sku?: string;
}

export interface DeviceDetails {
  offerId?: string;
}

export interface MixedCartObject {
  isAccessory?: boolean;
  isAccessoryCheckout?: boolean;
}

export interface MemoryMap {
  color: string;
  memoryArr: string[];
}
